import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { INGREDIENT_NODE_FRAGMENT } from '../fragments'

const DELETE_INGREDIENT_MUTATION = gql`
  mutation deleteIngredient($id: ID!) {
    deleteIngredient(id: $id) {
      results {
        ...IngredientNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${INGREDIENT_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default DELETE_INGREDIENT_MUTATION
